const generateLink = (code: string) => `${window.location.origin}/auth/signup?ref=${code}`;

export default generateLink;
